import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { CheckboxGroup, CheckTile, Heading } from '@eneco/sparky';
import { ElectricCar, Heatpump, Radiator, SwimmingPool } from '@eneco/sparky/illustrations';
import { SmartHomeBatteryRendering } from '@sitecore/types/SmartHomeBattery';
import { FieldValues, UseFormReturn } from 'react-hook-form';

const Step2: FC<{
  fields: SmartHomeBatteryRendering['fields'];
  formMethods: UseFormReturn<FieldValues, undefined>;
}> = ({ fields, formMethods }) => {
  const { register } = formMethods;
  const showSwimmingPool = false; // Temporarily set to false, because of Airtable licensing issues

  return (
    <>
      <Heading as="h2" size="M">
        {fields.step2Title.value}
      </Heading>
      <Heading as="h3" size="S">
        {fields.step2Subtitle.value}
      </Heading>
      <RichText html={fields.step2BodyContent.value} />
      <CheckboxGroup label="">
        <CheckTile
          icon={<ElectricCar size="small" />}
          {...register('hasEV')}
          subtitle={fields.step2FieldsHasEvHintText.value}>
          {fields.step2FieldsHasEvLabel.value}
        </CheckTile>
        <CheckTile
          icon={<Heatpump size="small" />}
          {...register('hasHeatPump')}
          subtitle={fields.step2FieldsHasHeatPumpHintText.value}>
          {fields.step2FieldsHasHeatPumpLabel.value}
        </CheckTile>
        <CheckTile
          icon={<Radiator size="small" />}
          {...register('hasElecHeating')}
          subtitle={fields.step2FieldsHasElecHeatingHintText.value}>
          {fields.step2FieldsHasElecHeatingLabel.value}
        </CheckTile>
        {showSwimmingPool && (
          <CheckTile
            icon={<SwimmingPool size="small" />}
            {...register('hasSwimPool')}
            subtitle={fields.step2FieldsHasSwimPoolHintText.value}>
            {fields.step2FieldsHasSwimPoolLabel.value}
          </CheckTile>
        )}
      </CheckboxGroup>
    </>
  );
};

export { Step2 };
export default Step2;
